<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.7265 8.09961C20.7265 5.65045 18.7417 3.66501 16.2924 3.66501H7.71043C5.26115 3.66501 3.27539 5.65045 3.27539 8.09961C3.27539 9.70332 3.27539 11.5657 3.27539 13.1694C3.27539 14.3455 3.74269 15.4735 4.57396 16.3052C5.40619 17.1368 6.53413 17.604 7.71043 17.604H8.58912C8.58912 18.4076 8.58912 19.7001 8.58912 19.7001C8.58912 19.9385 8.72464 20.1561 8.93791 20.2613C9.15212 20.3666 9.40712 20.3412 9.59575 20.1959L12.9654 17.604H16.2924C17.4677 17.604 18.5967 17.1368 19.4279 16.3052C20.2592 15.4735 20.7265 14.3455 20.7265 13.1694V8.09961ZM19.4753 8.09961V13.1694C19.4753 14.0138 19.1398 14.8235 18.5436 15.4206C17.9464 16.0176 17.136 16.353 16.2924 16.353C14.5009 16.353 12.7531 16.353 12.7531 16.353C12.6147 16.353 12.481 16.3986 12.3711 16.4827L9.8403 18.4298V16.9785C9.8403 16.633 9.55974 16.353 9.21471 16.353C9.21471 16.353 8.55971 16.353 7.71043 16.353C6.86588 16.353 6.05546 16.0176 5.45925 15.4206C4.8621 14.8235 4.52657 14.0138 4.52657 13.1694V8.09961C4.52657 6.34138 5.95214 4.91605 7.71043 4.91604H16.2924C18.0507 4.91605 19.4753 6.34138 19.4753 8.09961Z"
      fill="#757575"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.4089 8.43438H8.12571C7.78023 8.43438 7.5 8.7147 7.5 9.05989C7.5 9.40515 7.78023 9.6854 8.12571 9.6854H12.4089C12.7541 9.6854 13.0343 9.40515 13.0343 9.05989C13.0343 8.7147 12.7541 8.43438 12.4089 8.43438Z"
      fill="#757575"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.4739 11.156H8.12569C7.78012 11.156 7.5 11.4363 7.5 11.7815C7.5 12.1268 7.78012 12.407 8.12569 12.407H15.4739C15.8189 12.407 16.0996 12.1268 16.0996 11.7815C16.0996 11.4363 15.8189 11.156 15.4739 11.156Z"
      fill="#757575"
    />
  </svg>
</template>

<script>
export default {
  name: 'Chat'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
